import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SingleStoreModalComponent } from './single-store-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'shared/shared.module';
import {
    FcpCardModule,
    FcpFormFieldModule,
    FcpIconModule,
    FcpInputModule,
    FcpButtonModule,
    FcpAlertModule,
    FcpDropdownModule,
    FcpModalModule,
    FcpChipModule
} from 'fc-ui-components';
import { DirectivesModule } from 'app/directives/directives.module';
import { DetailedSizeFilterModule } from '../../detailed-size-filter/detailed-size-filter.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        FcpModalModule,
        FcpButtonModule,
        ReactiveFormsModule,
        SharedModule,
        FcpFormFieldModule,
        FcpIconModule,
        FcpInputModule,
        FcpCardModule,
        DirectivesModule,
        FcpAlertModule,
        FcpAlertModule,
        FcpAlertModule,
        FcpDropdownModule,
        DetailedSizeFilterModule,
        FcpChipModule
    ],
    declarations: [SingleStoreModalComponent],
    exports: [SingleStoreModalComponent]
})
export class SingleStoreModalModule {}
